// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import autoEvent from './js/widgets/autoEvent.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import gridGallery from './js/widgets/gridGallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  gridGallery();

  if (window.location.pathname === '/') {
    mainSlideshow();
    autoEvent();
    cardWidget();
    seoWidget();
    scrollerSponsors();

    $(window).load(function () {
      videoWidget();
    });
  }
});
